import { useMemo } from 'react';

import { isArrEmpty } from '../utils/arrayUtil';

const useReadAvailabilityBookMore = (availabilities, product, cartData = null) => {
  const { price_per_participant: isPricePerParticipant } = product ?? {};

  const checkCanBookMore = () => {
    // double equal to catch undefined too
    if (cartData == null) return true;
    if (isArrEmpty(availabilities)) return false;

    for (const availability of availabilities) {
      const canBookMore = canBookMoreAvailability(isPricePerParticipant, availability, cartData.ocSessionsWithResources);
      if (!canBookMore) {
        return false;
      }
    }
    return true;
  };

  const canBookMore = useMemo(() => checkCanBookMore(), [JSON.stringify(availabilities)]);
  return canBookMore;
};

export default useReadAvailabilityBookMore;

const canBookMoreAvailability = (isPricePerParticipant, availability, ocSessionsWithResources) => {
  if (isPricePerParticipant) {
    return canBookMoreInPerParticipantMode(availability, ocSessionsWithResources);
  }
  return canBookMoreInPerSessionMode(availability, ocSessionsWithResources);
};

const canBookMoreInPerParticipantMode = (availability, ocSessionsWithResources) => {
  const { nb_tickets: nbPlaces, session_group_id: sessionGroupId } = availability;
  if (nbPlaces == null) return true; // no limit on available places

  const { cartParticipants } = getAlreadyBookedData(sessionGroupId, ocSessionsWithResources);
  const placesStillAvailable = cartParticipants < nbPlaces;
  return placesStillAvailable;
};

const canBookMoreInPerSessionMode = (availability, ocSessionsWithResources) => {
  const { nb_tickets: nbPlaces, max_participants: maxParticipantsPerSession, session_group_id: sessionGroupId } = availability;
  if (nbPlaces == null) return true; // no limit on available places

  // having a number of places without a max participant would be a misconfiguration but we'll allow it..
  if (maxParticipantsPerSession == null) {
    console.warn('Product per session misconfig : nb_tickets set but max_participants not set.');
    return true;
  }

  const { cartLines } = getAlreadyBookedData(sessionGroupId, ocSessionsWithResources);

  // having a max > nbPlaces shouldnt happen as well but we'll manage in case
  const actualMaxParticipants = maxParticipantsPerSession > nbPlaces ? nbPlaces : maxParticipantsPerSession;

  // In the improbable case we have 10 places and 3 max, we floor() to get 3 sessions available, not ceil() to get 4
  const sessionsTotalAvailable = Math.floor(nbPlaces / actualMaxParticipants);

  // can book if some sessions are still available
  const sessionsStillAvailable = sessionsTotalAvailable - cartLines;
  return sessionsStillAvailable > 0;
};

const getAlreadyBookedData = (sessionGroupId, ocSessionsWithResources) => {
  let cartParticipants = 0;
  let cartLines = 0;
  ocSessionsWithResources.map(entry => {
    const groupedSessionGroups = entry[1];
    if (groupedSessionGroups.sessionGroupId === sessionGroupId) {
      cartParticipants += groupedSessionGroups.countParticipants;
      cartLines++;
    }
  });
  return { cartParticipants, cartLines };
};
